export default __webpack_public_path__ + "static/media/pizza.7ad40a9c.png";